import { nodeListToArray, scrollTo, debounce } from './modules/util.js';
import lj from '../lumberjack';

const isMobile = window.innerWidth < 1024;
Element.prototype.q = Element.prototype.querySelector;
Element.prototype.qa = function(selector) {
  return nodeListToArray(
    Element.prototype.querySelectorAll.call(this, selector)
  );
};

//dom declarations
const nav = document.querySelector('nav');
const rzpLogo = nav.q('#nav .rzp-logo');
const navItems = nav.qa('.nav-category');

$(document).ready(function() {
  const topContainer = $('#razorpay-x .topbar-container');

  $('#razorpay-x #ham-menu').click(function() {
    topContainer.hasClass('z-index-90')
      ? topContainer.removeClass('z-index-90')
      : topContainer.addClass('z-index-90');
  });
  $('#razorpay-x .backdrop').click(function() {
    topContainer.removeClass('z-index-90');
  });

  function togglePricePlanView(parent, currentEle) {
    let eleId = currentEle.data('href');
    if ($(`${parent} #${eleId}`).hasClass('active')) {
      currentEle.text('View more');
      $(`${parent} #${eleId}`).removeClass('active');
    } else {
      currentEle.text('View Less');
      $(`${parent} #${eleId}`).addClass('active');
    }
  }

  $('.nomob .view-more-plan-btn').click(function() {
    togglePricePlanView('.nomob', $(this));
  });

  $('.mobile .view-more-plan-btn').click(function() {
    togglePricePlanView('.mobile', $(this));
  });

  const taxPaymentLiteAnnouncementBanner = $(
    '#razorpay-x .tax-payment-lite-announcement-banner'
  );

  if (taxPaymentLiteAnnouncementBanner.length !== 0) {
    const taxPaymentLiteAnnouncementBannerLinks = taxPaymentLiteAnnouncementBanner.find(
      'a'
    );

    const taxPaymentLiteAnnouncementBannerTextContainers = taxPaymentLiteAnnouncementBanner.find(
      'span'
    );

    const taxPaymentLiteAnnouncementBannerTexts = [];
    const taxPaymentLiteAnnouncementBannerIds = [];

    taxPaymentLiteAnnouncementBannerTextContainers.each(function() {
      taxPaymentLiteAnnouncementBannerTexts.push($(this).text());
    });

    taxPaymentLiteAnnouncementBannerLinks.each(function(index) {
      taxPaymentLiteAnnouncementBannerIds.push($(this).attr('id'));
      $(this).on('click', function() {
        lj.pushEvents({
          event_name: 'website.click_banner_cta_tpl_gtm',
          event_type: 'initiated',
          properties: {
            bannerText: taxPaymentLiteAnnouncementBannerTexts[index],
            bannerId: taxPaymentLiteAnnouncementBannerIds[index]
          }
        });
      });
    });
  }
});
